<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.03.13</b> - Довольно серьёзное исправление ИИ</p>
    <div class="ml-5 pb-4 text-blue-500">
      <div class="font-bold mt-2">ИИ боя</div>
      <ul class="ml-4 list-disc">
        <li>
          Все деревья решений ИИ теперь проверяют, достаточно ли у юнитов ОД/МС для использования
          способностей (учитывая Адреналин / Мистическую концентрацию) перед их выбором, и переходят
          к другим способностям или узлам дерева перед началом следующего дерева. Это значительное
          изменение (ранее они просто выбирали способности без учёта стоимости ОД/МС), поэтому дайте
          знать, если заметите какие-либо новые проблемы. Возможно, вы захотите перенастроить
          некоторые из ваших отрядов, чтобы воспользоваться улучшенной логикой.
        </li>
      </ul>

      <div class="font-bold mt-2">Исправления ошибок</div>
      <ul class="ml-4 list-disc">
        <li>
          Исправлена обработка попыток обмена экипированных сумок с предметами, которые не являются
          сумками.
        </li>
        <li>
          Исправлена обработка ошибок при попытке войти в Пещеры без достаточного количества золота
        </li>
      </ul>
    </div>
  </div>
</template>
